module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v(_vm._s(_vm.$t('score_management')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container pb-5 bg-white mt-5"
  }, [(_vm.isEmpty) ? [_c('empty-page', {
    staticClass: "pt-5",
    attrs: {
      "title": _vm.$t('noData'),
      "description": _vm.$t('without_list_of_established information')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-1"
  }, [(_vm.type !== 'index') ? _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.go(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/icon/step_back.png")
    }
  })]) : _vm._e()])])] : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-3 border border-right-0 border-left-0 border-top-0 mb-5",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 offset-sm-2"
  }, [_c('div', {
    staticClass: "pb-4"
  }, [(_vm.type === 'course-students') ? _c('button', {
    staticClass: "btn btn-sm btn-primary ",
    on: {
      "click": function($event) {
        _vm.getAttachment(_vm.courseId, _vm.groupId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('download_excel')))]) : _vm._e()]), _vm._v(" "), (_vm.type === 'exam-students') ? _c('div', {
    staticClass: "border rounded pt-3 pb-3 pl-5 pr-5"
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('total')))]), _vm._v(" "), _c('th', [_vm._v("狀態")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-left"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: 'type-' + index
    }, [_c('td', [_vm._v(_vm._s(item.studentNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.realName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isExamed ? '已考' : '未考'))])])
  }), 0)])]) : _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: 'type-' + index,
      staticClass: "list-group-item d-flex justify-content-between p-0 rounded mb-3",
      class: {
        'border-right-0 border-left-0 border-top-0': _vm.type === 'student-lessons' || _vm.type === 'course-students'
      },
      on: {
        "mouseover": function($event) {
          _vm.pointer = item.id
        },
        "mouseout": function($event) {
          _vm.pointer = null
        }
      }
    }, [(_vm.type === 'index') ? [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "150%"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('br'), _vm._v(_vm._s(_vm.$t('teacher')) + "：" + _vm._s(item.teacherName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center justify-content-end",
      staticStyle: {
        "width": "430px"
      }
    }, [_c('transition', {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "d-none"
      }
    }, [(_vm.pointer !== item.id) ? _c('span', {
      staticClass: "pr-3 text-right"
    }, [_vm._v(_vm._s(_vm.$tc('student', item.studentCount, {
      count: item.studentCount
    })))]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "d-none"
      }
    }, [(_vm.pointer === item.id) ? _c('div', {
      staticClass: "w-100 text-right"
    }, [_c('icon-button', {
      attrs: {
        "name": "book",
        "alt": _vm.$t('assignment_score')
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'record-mgr.courses',
            params: {
              groupId: item.id
            }
          })
        }
      }
    })], 1) : _vm._e()])], 1)] : _vm._e(), _vm._v(" "), (_vm.type === 'course') ? [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "300%"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" （" + _vm._s(item.createTime) + "）\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center rounded list-group-item-playbtn"
    }, [_c('span', {
      staticClass: "w-100 text-center",
      on: {
        "click": function($event) {
          _vm.name = item.name;
          _vm.$router.push({
            name: 'record-mgr.course-students',
            params: {
              groupId: _vm.groupId,
              courseId: item.id
            }
          })
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/icon/btn_text_play.png"),
        "height": "12"
      }
    })])])] : _vm._e(), _vm._v(" "), (_vm.type === 'course-students') ? [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "150%"
      }
    }, [_vm._v("\n                " + _vm._s(item.studentNo) + " " + _vm._s(item.realName) + " "), _c('br'), _vm._v(_vm._s(_vm.$t('frequency_of_study')) + "：" + _vm._s(item.learnCount) + " " + _vm._s(_vm.$t('study_time')) + "：" + _vm._s(item.spendTime) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-2"
    }, [(item.isDone) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/icon/check_on.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/image/icon/check_off.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [_c('icon-button', {
      attrs: {
        "name": "more_dots",
        "alt": _vm.$t('more')
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'record-mgr.student-lessons',
            params: {
              courseId: _vm.courseId,
              studentId: item.id
            }
          })
        }
      }
    })], 1)] : _vm._e(), _vm._v(" "), (_vm.type === 'student-lessons') ? [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "300%"
      }
    }, [_vm._v("\n                " + _vm._s((index + 1)) + ". " + _vm._s(item.localName) + " "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [(item.isDone) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/icon/check_on.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/image/icon/check_off.png")
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.type === 'exam') ? [_c('div', {
      staticClass: "w-100 text-left p-3",
      staticStyle: {
        "line-height": "300%"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" （" + _vm._s(item.createTime) + "）\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center rounded list-group-item-playbtn"
    }, [_c('span', {
      staticClass: "w-100 text-center",
      on: {
        "click": function($event) {
          _vm.name = item.name;
          _vm.$router.push({
            name: 'record-mgr.exam-students',
            params: {
              groupId: _vm.groupId,
              courseId: item.id
            }
          })
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/image/icon/btn_text_play.png"),
        "height": "12"
      }
    })])])] : _vm._e()], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [(_vm.type !== 'index') ? _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.go(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/icon/step_back.png")
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.pageCount > 1) ? _c('div', {
    staticClass: "col-4 offset-3"
  }, [_c('pagination', {
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1) : _vm._e()])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7382d89b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingGroupRecord.vue
// module id = 740
// module chunks = 1